import jQuery from 'jquery';

const { UI } = Mobi2Go;
const { Order } = Mobi2Go;
const { Locations } = Mobi2Go;

UI.View({
    name: 'locations_opening_hours',
    model: Order,
    el: '[data-view="locations-opening-hours"]',
    template: jQuery('[data-template="locations-opening-hours"]').html(),
    initialise() {
        Locations.onReady(this.render);
    },
    render() {
        const html = this.template(Locations);
        this.$el.html(html);
    },

    scrollToOrderSectionAndSetLocation(location_id) {
        UI.helpers.scrollTo(
            '#Menu',
            function() {
                Order.setLocationById(location_id);
            },
            true
        );
    },

    scrollToScrollToMapSection(location_id) {
        UI.helpers.scrollTo(
            '.m2g-locations-map',
            function() {
                UI.trigger('showLocationOnMap', location_id);
            },
            true
        );
    },

    model_listeners: {},
    DOM_listeners: {
        'click [data-location] [data-map-link]': function(e) {
            const location_id = this.jQuery(e.currentTarget)
                .parent()
                .parent()
                .attr('data-location');
            this.scrollToScrollToMapSection(location_id);

            return false;
        },
        'click [data-location]': function(e) {
            const location_id = this.jQuery(e.currentTarget).attr(
                'data-location'
            );
            const location = Locations.getById(location_id);

            UI.trigger('showLocations', location);
        },
    },
});
